export default __webpack_public_path__ + "static/media/logos7.9f66a779.png";